export var UserType = 'user';
export var TeamType = 'team';
export var GroupType = 'group';
export var EmailType = 'email';